import { memo } from 'react';
import { Checkbox, ListItem, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import { ListboxRowProps } from './types';

// Every row is forced to this height so the windowing maths in ListboxWithCheckboxes can map a
// scroll offset to a row index. Changing it here is enough; the list imports this value.
export const ROW_HEIGHT = 48;

const ListboxRow = (props: ListboxRowProps): JSX.Element => {
  const { option, checked, onToggle, posInSet, setSize } = props;
  const disabled = !!option.isDisabled;

  return (
    <ListItem disablePadding dense sx={{ height: ROW_HEIGHT }}>
      <ListItemButton
        role="option"
        aria-selected={checked}
        aria-posinset={posInSet}
        aria-setsize={setSize}
        selected={checked}
        disabled={disabled}
        onClick={() => onToggle(option.value)}
        onKeyDown={e => {
          if (e.key === ' ' || e.key === 'Enter') {
            e.preventDefault();
            onToggle(option.value);
          }
        }}
        sx={{ height: '100%' }}
      >
        <ListItemIcon sx={{ minWidth: 36 }}>
          <Checkbox tabIndex={-1} checked={checked} disabled={disabled} />
        </ListItemIcon>
        <ListItemText primary={option.label} title={option.label} primaryTypographyProps={{ noWrap: true }} />
      </ListItemButton>
    </ListItem>
  );
};

export default memo(ListboxRow);
